import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * ActivitySidebar
 * Lista de atividades utilizando o componente padronizado NeoSideMenu.
 */
const ActivitySidebar = ({ activities = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar atividades baseado na pesquisa local
    const filteredActivities = activities.filter((activity) =>
        activity.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear atividades para o formato de itens do NeoSideMenu
    const sideMenuItems = filteredActivities.map((activity) => ({
        id: activity.id,
        label: activity.name,
        description: `${activity.objectives?.length || 0} objetivos`,
        badge: activity.status === GLOBAL_STATUS.ACTIVE ? "Ativa" : "Inativa",
        badgeVariant: activity.status === GLOBAL_STATUS.ACTIVE ? "success" : "muted",
        icon: activity.evaluationSystem ? "mdi-star" : "mdi-dumbbell",
        photoUrl: activity.photoUrl || null,
        color: activity.color || null
    }));

    return (
        <NeoSideMenu
            title="Atividades"
            subtitle="Metodologia e objetivos"
            icon="mdi-run-fast"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const activity = activities.find((act) => act.id === id);
                if (activity) onSelect(activity);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar atividade..."
                />
            }
        />
    );
};

ActivitySidebar.propTypes = {
    activities: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool,
};

export default ActivitySidebar;
